'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * i18n is the general usecase that most people will want to use. All instances of this module will share the same
 * templateLoader from forklifter, which provides caching benefits.
 */

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

var _forklifter = require('forklifter');

var _createi18n = require('./createi18n');

var _createi18n2 = _interopRequireDefault(_createi18n);

var locale = _user2['default'].getLocale();

var i18nBaseInstance = _createi18n2['default'](_forklifter.templateLoader, locale);

exports['default'] = i18nBaseInstance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-i18n/dist/i18n.js
// module id = 431
// module chunks = 0